import { SEC_TYPE } from 'const/stock'

/**
 * 判断是不是同一只标的
 * @param {object} stock1
 * @param {object} stock2
 */
export default function isSameStock(stock1, stock2) {
  if (!stock1 || !stock2) return false
  if (stock1.webLocal && stock2.webLocal) {
    return stock1.webLocal.symbol === stock2.webLocal.symbol
  }
  if (stock1.secType !== stock2.secType || stock1.symbol !== stock2.symbol) {
    return false
  }
  if (stock1.secType === SEC_TYPE.OPT) {
    return (
      stock1.strike === stock2.strike &&
      stock1.expiry === stock2.expiry &&
      stock1.right === stock2.right
    )
  }
  return stock1.symbol === stock2.symbol
}
